import React from 'react';

import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';

import { CheckboxLayer } from '../components/CheckboxLayer';
import { useResponsive } from '../hooks/useResponsive';
import { useLabel } from '../hooks/useLabel';

export const LayerListContainer = ({ layerConfig, handleLayer }) => {
  const { isDesktop, isMobile } = useResponsive();
  const { convertLabelLayer, convertExplainLabel } = useLabel();
  const { t } = useTranslation();

  const style = {
    container: {
      display: 'flex',
      paddingX: isDesktop ? null : '.3em',
      width: '95%',
    },
    backgroundContainer: {
      display: 'flex',
    },
    backgroundLabelContainer: {
      display: 'flex',
      width: '100%',
      height: '4em',
      textTransform: 'none',
      color: '#666666',
      '&:hover': {
        textDecoration: 'underline',
        backgroundColor: 'transparent',
      },
    },
    typeSelect: {
      display: 'flex',
      border: '0.3em solid',
      borderRadius: '1em',
      minWidth: isMobile ? '3em' : '4.3em',
      width: isMobile ? '3em' : '4.3em',
      height: isMobile ? '3em' : '4.3em',
      padding: 0,
    },
  };

  const convertGroupLabel = (g) =>
    ({
      sidewalk: t('sidebar.label_subtitle_sidewalk'),
      crossing: t('sidebar.label_subtitle_passage'),
      problems: t('sidebar.label_subtitle_errors'),
    })[g] || g;

  const grouped = Object.entries(layerConfig).reduce((acc, [key, cfg]) => {
    const grp = cfg.group || 'other';
    if (!acc[grp]) {
      acc[grp] = [];
    }
    acc[grp].push([key, cfg]);
    return acc;
  }, {});

  return (
    <Stack sx={style.container} spacing={2} direction='column'>
      {Object.entries(grouped).map(([grp, items]) => (
        <div
          key={grp}
          style={{
            marginBottom: 16,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <h3 style={{ marginBottom: '20px', marginLeft: '16px' }}>
            {convertGroupLabel(grp)}
          </h3>
          {items.map(([elem, cfg]) => (
            <CheckboxLayer
              key={elem}
              id={elem}
              value={cfg.visibility === 'visible'}
              label={convertLabelLayer(elem)}
              type={elem.includes('point') ? 'point' : 'line'}
              color={cfg.color}
              handleLayer={handleLayer}
              explain={convertExplainLabel(elem)}
            />
          ))}
        </div>
      ))}
    </Stack>
  );
};
